
import React, { useState, useEffect, FC, ChangeEvent } from 'react';

interface OdometerGPSProps {
  alarm: {
    type: string;
    name: string;
    group: string;
    threshold: number;
  };
  onChange: (updatedAlarm: OdometerGPSProps['alarm']) => void;
}

const OdometerGPS: FC<OdometerGPSProps> = ({ alarm, onChange }) => {
  const [threshold, setThreshold] = useState<number>(alarm.threshold);
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    setThreshold(alarm.threshold);
  }, [alarm.threshold]);

  const handleThresholdChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    // Vérification si la valeur est un nombre entier positif
    if (/^\d+$/.test(value)) {
      const parsed = parseInt(value, 10);
      setThreshold(parsed);
      setErrorMessage('');
      onChange({ ...alarm, threshold: parsed });
    } else {
      setErrorMessage('Please enter a valid number.');
    }
  };

  return (
<div className="form-group">
  <div style={{ position: 'relative', display: 'inline-block', width: '200px' }}>
    <input
      type="number"
      id="threshold"
      value={threshold}
      onChange={handleThresholdChange}
      className="form-control"
      min="0"
      step="1"
      pattern="\d*"
      style={{
        width: '100%',
        paddingRight: '50px',
        boxSizing: 'border-box'
      }}
    />
    <span
      style={{
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#333'
      }}
    >
      Km/h
    </span>
  </div>

  {errorMessage && (
    <div
      className="error-message"
      style={{
        backgroundColor: '#ff7e41',
        color: 'white',
        marginTop: '5px',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '0.9em',
        display: 'inline-block'
      }}
    >
      {errorMessage}
    </div>
  )}
</div>
  );
};

export default OdometerGPS;
